import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FiWind, FiThermometer, FiBarChart2, FiMap } from 'react-icons/fi';

const MobileTabLayout = ({ children, sections }) => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState(0);
    
    const tabs = [
        { id: 0, label: t('Overview'), icon: FiWind },
        { id: 1, label: t('Details'), icon: FiThermometer },
        { id: 2, label: t('Charts'), icon: FiBarChart2 },
        { id: 3, label: t('Map'), icon: FiMap }
    ];
    
    return (
        <div className="md:hidden">
            {/* Tab Navigation */}
            {/* Sticky just below NavigationHeader (h-14=56px) + StationDashboardHeader.
                Using top-28 (112px) lets the SDB (which is taller than 56px and has
                z-40) cover the top edge if there's overlap — eliminates the gap. */}
            <div className="sticky top-28 z-30 bg-white dark:bg-slate-800 border-b border-gray-200 dark:border-slate-700">
                <div className="flex">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`flex-1 flex items-center justify-center py-3 px-4 text-sm font-medium transition-colors ${
                                activeTab === tab.id
                                    ? 'text-blue-600 dark:text-blue-400 border-b-2 border-blue-600 dark:border-blue-400'
                                    : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
                            }`}
                        >
                            <tab.icon className="w-4 h-4 mr-2" />
                            {tab.label}
                        </button>
                    ))}
                </div>
            </div>
            
            {/* Tab Content */}
            <div className="min-h-screen">
                {sections[activeTab]}
            </div>
        </div>
    );
};

export default MobileTabLayout;